import {Injectable} from '@angular/core';
import {NgbDateParserFormatter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {DateService} from "./date.service";
import moment from 'moment';

export function toInteger(value: any): number {
  return parseInt(`${value}`, 10);
}

export function isNumber(value: any): value is number {
  return !isNaN(toInteger(value));
}

export function padNumber(value: number) {
  if (isNumber(value)) {
    return `0${value}`.slice(-2);
  } else {
    return '';
  }
}

const monthNameToIndex = {
  JAN: 1,
  FEB: 2,
  MAR: 3,
  APR: 4,
  MAY: 5,
  JUN: 6,
  JUL: 7,
  AUG: 8,
  SEP: 9,
  OCT: 10,
  NOV: 11,
  DEC: 12,
};

const monthNames = [
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUN',
  'JUL',
  'AUG',
  'SEP',
  'OCT',
  'NOV',
  'DEC',
];

@Injectable()
export class AirGatewayDateFormatter extends NgbDateParserFormatter {
  constructor(private dateService: DateService) {
    super();
  }
  parse(value: string): NgbDateStruct {
    if (value) {
      let stringLen = value.length;

      // Pad with zeros if necessary
      if (stringLen < 9) {
        value = value.padStart(7, '0');
      }

      const day = toInteger(value.substr(0, 2));
      const monthStr = value.substr(2, 3).toUpperCase();
      const month = monthNameToIndex[monthStr];
      const yearStr = value.substr(5, 2); // get the last two digits for the year

      let year = toInteger(yearStr);

      // Handle two-digit year
      if (year < 100) {
        year += year < 50 ? 2000 : 1900; // assuming anything below 50 is 2000s
      }

      // Only return valid dates
      if (month !== undefined && day > 0 && day <= 31) {
        return { year, month, day };
      }
    }

    return null; // Return null for invalid input
  }

  format(date: NgbDateStruct): string {
    return date ? moment.utc(`${date.day}-${date.month}-${date.year}`, 'DD-MM-YYYY').format(this.dateService.dateFormat).toUpperCase() : '';
  }

}
